import { GrayscalePalette } from '@tcl-boron-colors/colors';
import { createUseStyles } from 'react-jss';

import { routePageGutterStyleSheet } from '~/components/_common/routePageLayout/routePageGutters.styles';

export const usePatientWorkspaceBreadcrumbsStyles = createUseStyles({
  breadcrumbsWrapper: {
    backgroundColor: GrayscalePalette['100'],
    ...routePageGutterStyleSheet.breadcrumbBar,
    paddingBottom: 0,
  },
  breadcrumbsContent: routePageGutterStyleSheet.maxWidthInset,
});
